const normalizePath = (pathname: string) => (pathname === "/" ? pathname : pathname.replace(/\/+$/, ""));

export const isNewShipmentApprovalDetailPath = (pathname: string) =>
  /^\/new-shipments\/[^/]+\/shipment-(?:cost|receivable)\/[^/]+$/.test(normalizePath(pathname));
